import { Link } from "react-router-dom";
import {
  FaTwitter,
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import NavLinks from "./NavLinks";

const Footer = () => {
  return (
    <footer className="bg-blue-950 text-slate-300 pt-16 pb-2 px-5 bottom-0">
      <div className="grid gap-8 grid-cols-1 lg:grid-cols-2">
        <div className="">
          <div className="">
            <p className="font-extrabold text-lg">Useful links</p>

            <ul className="md:flex hidden items-center">
              <NavLinks />
            </ul>
            <ul className="md:hidden pl-4">
              <NavLinks />
            </ul>
          </div>
          <div className="my-4 border-2 border-red-600"></div>
          <div className="">
            <p className="font-extrabold text-lg">Our Socials</p>
            <div className="flex ">
              <Link className="text-slate-300 mb-2 p-4" to="#">
                <FaInstagram fontSize={20} className="text-4xl" />
              </Link>
              <Link className="text-slate-300 mb-2 p-4" to="#">
                <FaLinkedin fontSize={20} className="text-4xl" />
              </Link>
              <Link className="text-slate-300 mb-2 p-4" to="#">
                <FaYoutube fontSize={20} className="text-4xl" />
              </Link>
              <Link className="text-slate-300 mb-2 p-4" to="#">
                <FaTwitter fontSize={20} className="text-4xl" />
              </Link>
              <Link className="text-slate-300 mb-2 p-4" to="#">
                <FaFacebook fontSize={20} className="text-4xl" />
              </Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:items-end lg:justify-center">
          <div className="lg:w-1/2">
            <form action="" method="post" className="">
              <p className="font-extrabold text-lg">Newsletter</p>
              <div className="mb-4">
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                  placeholder="Enter Your Email"
                />
              </div>
              <button
                type="submit"
                className="bg-sky-500 hover:bg-sky-600 text-white font-bold py-2 px-4 rounded"
              >
                Subscribe
              </button>
            </form>
          </div>
          <div className="flex items-center pt-4">
            <p className="text-sm md:cursor-pointer">Terms & Conditions</p>
            <div className="mx-2 h-4 w-1 bg-red-600 border-2 border-red-600"></div>
            <p className="text-sm ">&copy; 2023 Marisu. All rights reserved.</p>
          </div>
        </div>
      </div>
      <div className="container mx-auto text-center">
        <p className="text-sm">Developed by Rades</p>
      </div>
    </footer>
  );
};

export default Footer;
